import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
// import DatePicker from "../DatePicker/DatePicker"
import FoliosSelect from "../Selects/FoliosSelect"
import CurrencyInput from "../CurrencyInput/CurrencyInput"
import TaxesSelect from "../ProductBuilder/TaxesSelect"
import DateHelper from "../DateHelper/DateHelper"

class RoomRevenueBuilder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // folio_item: this.props.folio_item,
      amount: 0,
      notes: '',
      item_type: 'cancellation',
      applyTaxesAndFees: true,
      item_date: this.props.folio_item.item_date || null,
      taxes: this.props.lodging_taxes || [],
      folio: this.props.folio || null,
    }

    this.onChangeApplyTaxesAndFees = this.onChangeApplyTaxesAndFees.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeNotes = this.onChangeNotes.bind(this);
    this.onChangeItemType = this.onChangeItemType.bind(this);
    this.onChangeItemDate = this.onChangeItemDate.bind(this);
    this.onChangeTaxes = this.onChangeTaxes.bind(this);
    this.onChangeFolio = this.onChangeFolio.bind(this);
  }

  render() {

    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ]

    return(
      <div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body">
                  <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_details')}</h5>
                  <div className="row">
                    <div className="col-sm-4 form-group">
                      <label>{I18n.t('item_type')}</label>
                      <select  onChange={this.onChangeItemType} className="form-control">
                        <option value="cancellation">{I18n.t('cancellation')}</option>
                        <option value="no_show">{I18n.t('no_show')}</option>
                        <option value="lodging">{I18n.t('lodging')}</option>
                      </select>
                    </div>

                    <div className="col-sm-4">
                      <label>{I18n.t('item_date')}</label>
                      <DatePicker minMax={true} min={DateHelper.parseDate(this.props.reservation_segment.check_in_date)} max={DateHelper.parseDate(this.props.reservation_segment.check_out_date)} name="item_date" value={DateHelper.parseDate(this.state.item_date)} onChange={this.onChangeItemDate} dateFormat={this.props.date_format}  />
                    </div>

                    <div className="col-sm-4">
                      <label>{I18n.t('folio')}</label>
                      <FoliosSelect folio={this.state.folio} reservation_segment_id={this.props.reservation_segment.id} onChange={this.onChangeFolio} />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <div className="panel panel-default">
                <div className="panel-body">
                  <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('item_amount')}</h5>
                  <div className="row">
                    <div className="col-sm-6 form-group">
                      <label>{I18n.t('amount')}</label>
                      {/* <input required="true" type="currency" className="form-control" min="1" onChange={(e) => this.onChangeAmount(e.target.value)} /> */}
                      <div className="input-group input-group-currency">
                        <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
                        <CurrencyInput className="form-control" name="amount"  value={this.state.amount ? this.state.amount : null} onChange={this.onChangeAmount}  />
                      </div>
                    </div>


                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('taxes')}</label>
                        <TaxesSelect lodging={true} taxes={this.state.taxes} onChange={this.onChangeTaxes} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="row">
          <div className="col-sm-12 form-group">
            <label>{I18n.t('notes')}</label>
            <textarea name="notes" defaultValue={this.state.notes} rows="6" className="form-control notes" onChange={this.onChangeNotes}></textarea>
          </div>
        </div>
        <ModalButtons loading={this.state.loading} buttons={buttons} />
      </div>
    )
  }

  onSave() {
    var self = this;
    self.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: this.props.room_revenue_create_path,
      data: {
        // update reservation_segment params
        folio_item: {
          subtotal: self.state.amount,
          total_amount: self.state.amount,
          folio_id: self.state.folio.id,
          item_date: self.state.item_date,
        },
        folio_item_notes: self.state.notes,
        item_type: self.state.item_type,
        tax_ids: self.state.taxes.map((tax) => tax.id),
      },
    }).done(function(data) {

      if (data.errors && data.errors.length) {
        // errors 
      } else {

        if(parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('folio_item_saved_successfully'));
        }
        
        window.parent.$(window.parent).trigger("reservationSavedSuccessfully")

        if(parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })

  }

  onChangeTaxes(newTaxes) {
		if (newTaxes) {
			this.setState({taxes: newTaxes})
		}
	}

  onChangeItemDate(date) {
    this.setState({
      item_date: date,
    });
  }

  onChangeFolio(folio) {
    this.setState({
      folio: folio,
    })

  }

  onChangeNotes(noteText) {
    this.setState({
      notes: noteText
    })
  }

  onChangeApplyTaxesAndFees(value) {
    this.setState({
      applyTaxesAndFees: value
    })
  }

  onChangeAmount(amount) {
    this.setState({
      amount: amount,
    })
  }

  onChangeItemType(e) {
    this.setState({
      item_type: e.target.value,
    })
  }
}

export default RoomRevenueBuilder